import { render, staticRenderFns } from "./ConfirmPrestas.vue?vue&type=template&id=ea19bf6a&scoped=true"
import script from "./ConfirmPrestas.vue?vue&type=script&lang=js"
export * from "./ConfirmPrestas.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPrestas.vue?vue&type=style&index=0&id=ea19bf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea19bf6a",
  null
  
)

export default component.exports